import { render, staticRenderFns } from "./policy-detail.vue?vue&type=template&id=04a7d44c&scoped=true&"
import script from "./policy-detail.vue?vue&type=script&lang=js&"
export * from "./policy-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a7d44c",
  null
  
)

export default component.exports